import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_COFFEE_GEO_PROFILE_QUALITY = createFcmConfig('coffee_geo_profile_quality', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
